module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/cooking/grater-2524e957903810218df91d3053151cc6.svg";